<template>
    <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
        <i class="fal fa-spinner fa-spin" /> Attribute List Data Loading...
    </div>
    <div v-else>
        <div class="animated">
            <basic-heading title="Attribute List" class="mb-3"></basic-heading>
            <AttributesListsCard :attribute="attributeList" />
            <AttributesListRelatedTabs v-if="showRelatedTabs" :attribute="attributeList" />
        </div>
    </div>
</template>
<script>
import AttributeListCollection from '@/collections/lab/AttributeListCollection';
import BasicHeading from "@/components/shared/BasicHeading";
import AttributesListsCard from '@/components/lab/attributeslists/AttributesListsCard.vue';
import AttributesListRelatedTabs from '@/components/lab/attributeslists/AttributesListRelatedTabs.vue';

export default {
    name: "AttributeListsDetail",
    components: {
        BasicHeading,
        AttributesListsCard,
        AttributesListRelatedTabs,
    },
    computed: {
        id() {
            return this.$route.params.id || null;
        },
        attributeList() {
            return (
                this.attributeLists &&
                this.attributeLists.find((list) => list.id === this.id)
            );
        },
        showRelatedTabs() {
            return this.attributeList && this.attributeList.children && this.attributeList.children.length;
        }
    },
    data() {
        return {
            attributesListsCollection: new AttributeListCollection(),
            attributeLists: null,
            loading: true,
        };
    },
    methods: {
        async init() {
            await this.fetch();
        },
        fetch() {
            const fetches = [];
            const Filter = this.attributesListsCollection.getFilter();
            Filter.filterEquals("id", this.id);
            fetches.push(
                this.attributesListsCollection.fetch().then(({ response }) => {
                    if (response && response.status === 200 && response.data) {
                        this.attributeLists = response.data.data;
                    }
                })
            );
            return Promise.all(fetches);
        }
    },
    watch: {
        id: {
            handler() {
                this.loading = true;
                this.init().finally(() => this.loading = false);
            },
            immediate: true,
        }
    },
};
</script>